import { FilterGroup } from 'types';
import { notEmpty } from '@/utilities/helpers';
import { IGetFilterGroupsProps } from '..';
import { getTagsFilter } from './tags/tags';

export const getOtherGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'OTHER',
    filters: [getTagsFilter(props)].filter(notEmpty),
  };
};
